import { tv } from 'tailwind-variants'

export const screenStyles = tv({
	slots: {
		base: 'flex bg-screen_bg web:w-full',
		keyboardAvoidingView: 'flex h-full w-full',
		screenContainer: 'flex h-full w-full',
		screenContent: 'h-full w-full',
	},
})
